<template>
  <div>
    <template v-if="isAllowDeletePerform">
      <v-btn class="error ml-2" @click="deletePerformDialogLocal = true">Удалить статус (Статусни ўчириш)</v-btn>
      <v-dialog v-model="deletePerformDialogLocal" max-width="600px" :persistent="true">
        <DeletePerform @close="deletePerformDialogLocal = false" :mail="mail"/>
      </v-dialog>
    </template>

    <template v-if="isAllowUnsetPostPackageMail">
      <v-btn class="error ml-2" @click="unsetPostPackageDialogLocal = true">Досыл(Бошқа манзилга юбориш)</v-btn>
      <v-dialog v-model="unsetPostPackageDialogLocal" max-width="600px" :persistent="true">
        <MailUnsetPostPackage @close="unsetPostPackageDialogLocal = false" :mail="mail"/>
      </v-dialog>
    </template>

    <!--    <template v-if="isAllowTryPerform">-->
    <!--      <v-btn color="info" class="ml-1" @click="tryPerformDialogLocal = true">Попытка вручения</v-btn>-->
    <!--      <v-dialog v-model="tryPerformDialogLocal" max-width="600px" :persistent="true">-->
    <!--        <TryPerform @close="tryPerformDialogLocal = false" :mail="mail" ref="tryPerform"/>-->
    <!--      </v-dialog>-->
    <!--    </template>-->

    <template v-if="isAllowDeliveryPerform">
      <v-btn class="ml-2" color="success" @click="deliveredDialogLocal = true">Вручено(Топширилди)</v-btn>
      <v-dialog v-model="deliveredDialogLocal" max-width="600px" :persistent="true">
        <SuccessDeliveredPerform @close="deliveredDialogLocal = false" :mail-history="mailHistory" :mail="mail" ref="successDeliveredPerform"/>
      </v-dialog>
    </template>

    <template v-if="isAllowFailedPerform">
      <v-btn color="error" class="ml-2" @click="failedDialogLocal = true">Возврат(Қайтариш)</v-btn>
      <v-dialog v-model="failedDialogLocal" max-width="800px" :persistent="true">
        <FailedDeliveryPerform @close="failedDialogLocal = false" :mail-history="mailHistory" :mail="mail" ref="failedDeliveredPerform"/>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import SuccessDeliveredPerform from "@/components/mail/perform/SuccessDeliveredPerform";
import FailedDeliveryPerform from "@/components/mail/perform/FailedDeliveryPerform";
// import TryPerform from "@/components/mail/perform/TryPerform";
import MailUnsetPostPackage from "@/components/mail/MailUnsetPostPackage";
import DeletePerform from "@/components/mail/perform/DeletePerform";
import {AllowDeleteFromPostPackage} from "@/enums/permission";
import _ from "underscore";

export default {
  name: "PerformButtons",
  props: {
    mail: {
      type: Object,
      default: null
    },
    mailHistory : {
      type: Array,
      default: null
    },
    failedDialog: {
      type: Boolean,
      default: false
    },
    deliveredDialog: {
      type: Boolean,
      default: false
    },
    tryPerformDialog: {
      type: Boolean,
      default: false
    },
    unsetPostPackageDialog: {
      type: Boolean,
      default: false
    },
    deletePerformDialog: {
      type: Boolean,
      default: false
    },
  },
  components: {
    DeletePerform,
    SuccessDeliveredPerform,
    FailedDeliveryPerform,
    // TryPerform,
    MailUnsetPostPackage
  },
  data() {
    return {
      failedDialogLocal: this.failedDialog,
      deliveredDialogLocal: this.deliveredDialog,
      tryPerformDialogLocal: this.tryPerformDialog,
      unsetPostPackageDialogLocal: this.unsetPostPackageDialog,
      deletePerformDialogLocal: this.deletePerformDialog,
    }
  },
  computed: {
    isAllowFailedPerform() {
      return this.mail.allowFailedPerform && this.$store.getters.appLogin.id === 11
    },
    isAllowDeliveryPerform() {
      return this.mail.allowDeliveryPerform && this.$store.getters.appLogin.id === 11
    },
    isAllowTryPerform() {
      return this.mail.allowTryPerform && this.$store.getters.appLogin.id === 11
    },
    isAllowUnsetPostPackageMail() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeleteFromPostPackage
      })
    },
    // isAllowUnsetPostPackageMail() {
    //   let allowDeleteFromPostPackage = !!_.find(this.$store.getters.appLogin.permissions, p => {
    //     return p === AllowDeleteFromPostPackage
    //   })
    //   //
    //   // let isAncientPrintPackage = this.mail.printPackage?.uid.startsWith('XPPL')
    //   // let isAncientPostPackage = this.mail.postPackage?.uid.startsWith('XPSL')
    //
    //   return [11, 564, 45, 30, 262, 225, 246, 2242, 44, 1060, 43, 1025, 931].includes(this.$store.getters.appLogin.id);
    // },
    isAllowDeletePerform() {
      return this.mail.isPerformed && this.$store.getters.appLogin.id === 11
    },
    isOperatorLogin() {
      return this.$store.getters.appIsOperatorLogin;
    }
  },
  methods: {
    onDeletePerformClicked() {
      this.$emit('delete-perform')
    }
  }
}
</script>

<style scoped>

</style>
